import { API_URL } from "./constants";

import { sendRequest } from "./utils";

export const sendCreatePartyRequest = async (jwtToken, partyName) => {
  const path = "/parties";
  const body = JSON.stringify({ partyName });
  const error = { message: "Cannot create party" };
  const options = {
    method: "PUT",
    credentials: "include",
    headers: {
      authorization: `Bearer ${jwtToken}`,
      "Content-Type": "application/json",
    },
    body,
  };
  return sendRequest({
    path,
    options,
    expectJson: true,
    error,
    url: API_URL,
  });
};

export const sendGetPartyRequest = async (partyId) => {
  const path = `/parties/${partyId}`;
  return sendRequest({ url: API_URL, path, expectJson: true });
};

export const sendVoteRequest = async (trackId, partyId, participantId) => {
  if (!partyId) {
    return {
      ok: false,
      message: "No partyId",
      status: 400,
    };
  }
  const error = { message: "Cannot vote" };
  const path = "/parties/vote";
  const body = JSON.stringify({
    trackId,
    userId: participantId.toString(),
    partyId: partyId.toString(),
  });
  const options = {
    method: "PUT",
    headers: new Headers({ "Content-Type": "application/json" }),
    body,
  };
  return sendRequest({ url: API_URL, path, options, expectJson: true, error });
};

export const sendInitializePlaybackRequest = async (partyId, jwtToken) => {
  const path = `/me/initialize/${partyId}`;
  const options = {
    method: "PUT",
    credentials: "include",
    headers: new Headers({
      Authorization: `Bearer ${jwtToken}`,
    }),
  };
  return sendRequest({ path, options, url: API_URL });
};

export const sendPlaybackCommandRequest = async (
  command,
  partyId,
  jwtToken,
) => {
  const path = `/me/playback/${partyId}`;
  const body = JSON.stringify({
    command,
    partyId,
  });
  const options = {
    method: "PUT",
    headers: new Headers({
      "Content-Type": "application/json",
      Authorization: `Bearer ${jwtToken}`,
    }),
    body,
    credentials: "include",
  };
  return sendRequest({ url: API_URL, path, options, expectJson: false });
};

export const sendSelectDeviceRequest = async (deviceId, partyId, jwtToken) => {
  console.log("sendSelectDeviceRequest");
  console.log(deviceId);
  console.log(partyId);
  console.log(jwtToken);
  const path = `/me/setDevice`;
  const body = JSON.stringify({
    deviceId,
    partyId,
  });
  console.log("body");
  console.log(body);
  const options = {
    method: "PUT",
    credentials: "include",
    headers: new Headers({
      "Content-Type": "application/json",
      Authorization: `Bearer ${jwtToken}`,
    }),
    body,
  };
  return sendRequest({ url: API_URL, path, options, expectJson: false });
};

export const sendGetDevicesRequest = async (jwtToken) => {
  const path = `/me/devices`;
  const options = {
    method: "GET",
    credentials: "include",
    headers: new Headers({
      "Content-Type": "application/json",
      Authorization: `Bearer ${jwtToken}`,
    }),
  };
  return sendRequest({ url: API_URL, path, options, expectJson: true });
};

export const sendGetPlaylistsRequest = async (jwtToken) => {
  const path = `/me/playlists`;
  const options = {
    method: "GET",
    credentials: "include",
    headers: new Headers({
      Authorization: `Bearer ${jwtToken}`,
    }),
  };
  return sendRequest({ url: API_URL, path, options, expectJson: true });
};

export const sendSetPlaylistRequest = async (
  playlistId,
  userId,
  partyId,
  jwtToken,
) => {
  const path = `/me/setPlaylist`;
  const body = JSON.stringify({
    playlistId,
    partyId,
    userId,
  });
  const options = {
    method: "PUT",
    credentials: "include",
    body,
    headers: new Headers({
      "Content-Type": "application/json",
      Authorization: `Bearer ${jwtToken}`,
    }),
  };
  return sendRequest({ url: API_URL, path, options, expectJson: false });
};

export const sendGetPrivateCredentialsRequest = async (jwtToken) => {
  const path = `/t/me`;
  const options = {
    method: "GET",
    credentials: "include",
    headers: new Headers({
      Authorization: `Bearer ${jwtToken}`,
    }),
  };
  return sendRequest({ url: API_URL, path, options, expectJson: true });
};
export const sendGetNearbyPartiesRequest = async () => {
  const path = `/parties`;
  const options = {
    method: "GET",
  };
  return sendRequest({ url: API_URL, path, options, expectJson: true });
};
